import React, {useState, useEffect} from 'react';
import {Form, InputNumber, Space} from 'antd';

interface props {
    onChange?: any,
    value?: any,
    enums?: any,
    placeholder?: string,
    max?: number,
    name?: string,
    required?: boolean,
    message?: string,
    min?: number,
    initialValue?: number
}

const SPMaxTime: React.FC<props> = (props) => {
    const {onChange, value, enums, placeholder, name, required, message, max, min, initialValue} = props;
    const [maxTime, setMaxTime] = useState<any>(null);

    const form = Form.useFormInstance();


    useEffect(() => {
        if (maxTime) {
            onChange(maxTime)
        }
    }, [maxTime]);

    useEffect(() => {
        if (value) {
            form.setFieldsValue(value)
        }
    }, []);

    return (
        <Space>
            <Space>
                <Form.Item
                    name={name}
                    rules={[{
                        required: required,
                        message: message
                    }]}
                    initialValue={initialValue}
                    noStyle
                >
                    <InputNumber
                        placeholder={placeholder}
                        step={1}
                        precision={0}
                        min={min}
                        max={max}
                        style={{width: '300px'}}
                        addonAfter="天"
                        onChange={value => setMaxTime(value)}
                    />
                </Form.Item>
                <span>对客展示最大提前预订期为180天，请确认未来日期租金的准确性</span>
            </Space>
        </Space>
    )
}

export default SPMaxTime